import styled from 'styled-components'

export const Container = styled.div`
  margin-top: 16px;
  margin-bottom: 40px;
`

export const Banner = styled.div`
  margin-top: 8px;
`
